<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <form @submit.prevent="navigate(1)">
                        <div class="row">
                            <div class="col-md-20">
                                <div class="form-group">
                                    <input
                                            v-model="filters.search"
                                            type="text"
                                            class="form-control input-sm"
                                            placeholder="Search..."
                                    >
                                </div>
                            </div>

                            <div class="col-md-4">
                                <button type="submit" class="btn btn-default btn-block btn-black btn-sm">
                                    <i class="fa fa-filter"></i> Filter
                                </button>
                            </div>
                        </div>
                    </form>

                    <table class="table table-condensed table-striped">
                        <thead>
                        <tr>
                            <th class="col-xs-1 text-center">
                                <input type="checkbox" :disabled="true">
                            </th>

                            <th class="col-xs-6">
                                Name
                            </th>

                            <th class="col-xs-6">
                                Att.
                            </th>

                            <th class="col-xs-8">
                                Address
                            </th>

                            <th class="col-xs-2">
                                Count
                            </th>

                            <th class="col-xs-1"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="magazineRecipient in magazineRecipients.data">
                            <td class="text-center">
                                <input type="checkbox" :disabled="true">
                            </td>

                            <td class="ellipsis">
                                <span v-tooltip="getName(magazineRecipient)">
                                    {{ getName(magazineRecipient) }}
                                </span>
                            </td>

                            <td class="ellipsis">
                                <span v-tooltip="getAttention(magazineRecipient)">
                                    {{ getAttention(magazineRecipient) }}
                                </span>
                            </td>

                            <td class="ellipsis">
                                <span v-tooltip="getAddress(magazineRecipient)">
                                    {{ getAddress(magazineRecipient) }}
                                </span>
                            </td>

                            <td>
                                {{ magazineRecipient.count }}
                            </td>

                            <td class="text-right">
                                <div class="btn-group list-actions">
                                    <router-link
                                            class="btn btn-sm"
                                            :to="getLink(magazineRecipient)"
                                    >
                                        <i class="fa fa-search"></i>
                                    </router-link>

                                    <button type="button" class="btn btn-sm" @click="destroy(magazineRecipient)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!magazineRecipients.data.length">
                            <td colspan="6" class="text-center">
                                <i>
                                    There are no magazine recipients to display.
                                </i>
                            </td>
                        </tr>
                        </tbody>
                    </table>


                    <div class="row">
                        <div class="col-xs-offset-6 col-xs-12">
                            <pager :pagination="magazineRecipients.meta" @navigate="navigate"></pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import Pager from '@/components/Lists/Pager'

    export default {
        components: {LoadingContainer, Pager},

        model: {
            prop: 'portal',
            event: 'portal-updated'
        },

        props: ['portal'],

        data() {
            return {
                magazineRecipients: null,
                filters: {
                    search: this.getQueryParam('search'),
                    page: this.getQueryParam('page', 1)
                },
                loading: true
            }
        },
        watch: {
            '$route'() {
                this.fetch()
            }
        },

        mounted() {
            this.fetch()
        },

        computed: {
            queryString() {
                return '?' + _(this.filters).pickBy().map((value, key) => key + '=' + value).join('&')
            },
        },

        methods: {
            fetch() {
                this.loading = true

                http.get('/api/v1/magazine-recipients', {
                    ...this.filters,
                    portal: this.portal.id,
                    active: true,
                    page_size: 25
                })
                    .then(response => {
                        this.magazineRecipients = response.data

                        this.loading = false
                    })
            },

            destroy(magazineRecipient) {
                modal.confirm('Are you sure that you want to delete the magazine recipient?', () => {
                    http.delete('/api/v1/magazine-recipients/' + magazineRecipient.id)
                        .then(() => {
                            notify.success('The magazine recipient was deleted')

                            this.navigate(1)
                        })
                })
            },

            navigate(page) {
                this.filters.page = page

                let url = '/portals/' + this.portal.id + '/magazine-recipients' + this.queryString

                if (url === this.$route.fullPath) {
                    this.fetch()
                }

                this.$router.push(url)
            },

            getQueryParam(key, defaultValue = null) {
                return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
            },

            getLink(magazineRecipient) {
                return '/' + magazineRecipient.subscription.subscriber_type + '/' + magazineRecipient.subscription.subscriber_id + '/subscriptions/' + magazineRecipient.subscription_id
            },

            getName(magazineRecipient) {
                if (magazineRecipient.company) {
                    return magazineRecipient.company.name
                }

                return magazineRecipient.person.name
            },

            getAttention(magazineRecipient) {
                if (magazineRecipient.attention) {
                    return magazineRecipient.attention
                }

                if (magazineRecipient.company && magazineRecipient.person) {
                    return magazineRecipient.person.name
                }

                return ''
            },

            getAddress(magazineRecipient) {
                if (magazineRecipient.address) {
                    return magazineRecipient.address.street_address + ', ' + magazineRecipient.address.zip_code_and_city
                }

                if (magazineRecipient.company) {
                    return magazineRecipient.company.address.street_address + ', ' + magazineRecipient.company.address.zip_code_and_city
                }

                return magazineRecipient.person.address.street_address + ', ' + magazineRecipient.person.address.zip_code_and_city
            }
        }
    }
</script>
